






























import {Vue, Component} from "vue-property-decorator";
import Cognito from "@/authorization/cognito";
import Translate from "@/consoleapi/api/translate";

@Component
export default class Change extends Vue {
    private currentPassword = '';
    private changedPassword = '';

    private changedPasswordConfirm = '';

    changePassword() {
        if (!this.validation()) {
            return;
        }
        const cognito = new Cognito();
        cognito.passwordChange(this.$cookies.get('userName'), this.currentPassword, this.changedPassword)
            .then(() => {
                this.$store.dispatch('changePassword/pushProgress', 'result');
            }).catch(err => {
                this.translate(err.message || JSON.stringify(err));
                //console.log(err);
        });
    }

    translate(message: string) {
        const translate = new Translate();
        translate.get(message)
            .then(response => {
                alert(response.data.text);
            })
            .catch(err => {
                //console.log(err.response);
                alert(message);
            })
    }

    validation() {
        if (!this.currentPassword) {
            alert('現在のパスワードを入力してください。');
            return false;
        }
        if (!this.changedPassword) {
            alert('新しいパスワードを入力してください。');
            return false;
        }
        if (this.changedPassword !== this.changedPasswordConfirm) {
            alert('確認用パスワードが一致しません');
            return false;
        }
        if (this.currentPassword === this.changedPassword) {
            alert('現在のパスワードと新しいパスワードが同一の内容です。\n' +
                '異なるパスワードを設定してください。');
            return false;
        }
        return true;
    }

    // パスワード表示トグル
    private isChecked?: boolean = false;

    get inputType(){
        return this.isChecked ? "text" : "password"
    }

    get iconType(){
        return this.isChecked ? "eye" : "eye-slash";
    }

    toggle(){
        this.isChecked = !this.isChecked;
    }
}
